import { render, staticRenderFns } from "./pass.vue?vue&type=template&id=d12b827a&scoped=true"
import script from "./pass.vue?vue&type=script&lang=js"
export * from "./pass.vue?vue&type=script&lang=js"
import style0 from "./pass.vue?vue&type=style&index=0&id=d12b827a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12b827a",
  null
  
)

export default component.exports